import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'xCheckbox', 'otherField', 'otherLabel', 'otherHint',
    'painCheckbox', 'painField', 'painLabel', 'painHint'
  ]

  connect() {
    this.#syncCheckbox(this.xCheckboxTarget, this.otherFieldTarget)
    this.#syncCheckbox(this.painCheckboxTarget, this.painFieldTarget)
    this.toggle()
  }

  syncOther() {
    this.#syncCheckbox(this.xCheckboxTarget, this.otherFieldTarget)
    this.toggle()
  }

  syncPain() {
    this.#syncCheckbox(this.painCheckboxTarget, this.painFieldTarget)
    this.toggle()
  }

  toggle() {
    this.#applyRequired(
      this.xCheckboxTarget.checked,
      this.otherFieldTarget,
      this.otherLabelTarget,
      this.otherHintTarget,
      'Other Complaint'
    )

    this.#applyRequired(
      this.painCheckboxTarget.checked,
      this.painFieldTarget,
      this.painLabelTarget,
      this.painHintTarget,
      'Pain Site'
    )
  }

  #syncCheckbox(checkbox, field) {
    checkbox.checked = !!field.value.trim()
  }

  #applyRequired(required, field, label, hint, labelText) {
    field.required = required
    hint.classList.toggle('hidden', !required)
    label.innerHTML = required
      ? `${labelText} <span class="text-red-500">*</span>`
      : labelText
  }
}
